'use client'

import { memo } from 'react'

import Button from 'shared/ui/Button'
import { ButtonVariants } from 'shared/ui/Button/Button.enums'

import styles from './DeliveryTimeOfDayButtons.module.scss'

interface DeliveryTimeOfDayButtonsProps {
  onTimeOfDayChange: (timeOfDay: string) => void
}

const TIME_OF_DAY_LABELS = {
  morning: 'Rano',
  afternoon: 'Popołudnie',
  evening: 'Wieczór'
} as const

/**
 * Mobile navigation buttons for quick scrolling to different times of day
 * Only visible on mobile/tablet devices
 */
const DeliveryTimeOfDayButtons: React.FC<DeliveryTimeOfDayButtonsProps> = ({
  onTimeOfDayChange
}) => {
  return (
    <div className={styles.mobileContent}>
      <div className={styles.deliveryTimesOfTheDay}>
        {(
          Object.keys(TIME_OF_DAY_LABELS) as Array<
            keyof typeof TIME_OF_DAY_LABELS
          >
        ).map(timeOfDay => (
          <Button
            key={timeOfDay}
            variant={ButtonVariants.tertiaryOutline}
            onClick={() => onTimeOfDayChange(timeOfDay)}
          >
            {TIME_OF_DAY_LABELS[timeOfDay]}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default memo(DeliveryTimeOfDayButtons)
